import { CurrentForecast } from '@/models/CurrentForecast';
import { QuarteredForecast } from '@/models/QuarteredForecast';
import { AppConfig } from '@/utils/AppConfig';
import { isDatePast } from '@/utils/DateUtils';
import {
  currentForecastTemplate,
  precipitationForecastTemplate,
  todayTemperatureTemplate,
  tomorrowForecastTemplate,
} from '@/utils/faq/FaqStringTemplates';

export interface FAQDataItem {
  question: string;
  answer: string;
}

export const generateFAQData = (
  currentForecast: CurrentForecast,
  quarteredForecast: QuarteredForecast[],
  city: string
): FAQDataItem[] => {
  const { temperature, windTemperature, description, windDirection, windSpeed, relativeHumidity } = currentForecast;
  const [todayForecast, tomorrowForecast] = quarteredForecast
    .filter((day) => !isDatePast(day.date, AppConfig.serverDate))
    .slice(0, 2);

  const faqData: FAQDataItem[] = [
    {
      question: currentForecastTemplate.question(city),
      answer: currentForecastTemplate.answer(city, {
        currentTemperature: temperature,
        windTemperature,
        description,
        windDirection,
        windSpeed,
      }),
    },
  ];

  if (todayForecast) {
    faqData.push(
      {
        question: todayTemperatureTemplate.question(city),
        answer: todayTemperatureTemplate.answer(city, {
          currentTemperature: temperature,
          windTemperature,
          morningTemperature: todayForecast.morning.temperature,
          dayTemperature: todayForecast.day.temperature,
          eveningTemperature: todayForecast.evening.temperature,
          nightTemperature: todayForecast.night.temperature,
        }),
      },
      {
        question: precipitationForecastTemplate.question(city),
        answer: precipitationForecastTemplate.answer(city, {
          currentDescription: description.toLowerCase(),
          expectedDescription: todayForecast.description.toLowerCase(),
          humidity: relativeHumidity,
        }),
      }
    );
  }

  if (tomorrowForecast) {
    faqData.push({
      question: tomorrowForecastTemplate.question(city),
      answer: tomorrowForecastTemplate.answer(city, {
        minTemperature: tomorrowForecast.temperatureLow,
        maxTemperature: tomorrowForecast.temperatureHigh,
        description: tomorrowForecast.description,
      }),
    });
  }

  return faqData;
};
